import { render, staticRenderFns } from "./ProductFormVariants.vue?vue&type=template&id=4dcf0e18&"
import script from "./ProductFormVariants.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports